import { PublicClientApplication, Configuration, SilentRequest, InteractionRequiredAuthError } from "@azure/msal-browser";

import { API_BASE_URL } from './config';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:1337/api";
const SSO_JWT_KEY = "itpmng_sso_jwt";
const SSO_USER_KEY = "itpmng_sso_user";

let msalInstance: PublicClientApplication | null = null;

export interface SsoConfig {
  endUserOauth: { enabled: boolean; clientId?: string; tenantId?: string };
}

export async function fetchSsoConfig(): Promise<SsoConfig> {
  const res = await fetch(`${API_BASE_URL}/icl-oauth-sso/sso-config`);
  if (!res.ok) return { endUserOauth: { enabled: false } };
  return res.json();
}

export async function initMsal(clientId: string, tenantId: string): Promise<PublicClientApplication> {
  const config: Configuration = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: window.location.origin,
    },
    cache: { cacheLocation: "sessionStorage" },
  };
  msalInstance = new PublicClientApplication(config);
  await msalInstance.initialize();
  return msalInstance;
}

export function getMsalInstance(): PublicClientApplication | null {
  return msalInstance;
}

export async function acquireToken(): Promise<string | null> {
  if (!msalInstance) return null;
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;
  const request: SilentRequest = {
    scopes: ["User.Read"],
    account: accounts[0],
  };
  try {
    const result = await msalInstance.acquireTokenSilent(request);
    return result.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({ scopes: ["User.Read"] });
    }
    return null;
  }
}

export async function exchangeToken(azureToken: string): Promise<{ jwt: string; user: any } | null> {
  const res = await fetch(`${API_BASE_URL}/icl-oauth-sso/token-exchange`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ accessToken: azureToken }),
  });
  if (!res.ok) return null;
  const data = await res.json();
  sessionStorage.setItem(SSO_JWT_KEY, data.jwt);
  sessionStorage.setItem(SSO_USER_KEY, JSON.stringify(data.user));
  return data;
}

export function getSsoJwt(): string | null {
  return sessionStorage.getItem(SSO_JWT_KEY);
}

export function getSsoUser(): any | null {
  const raw = sessionStorage.getItem(SSO_USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function clearSsoSession(): void {
  sessionStorage.removeItem(SSO_JWT_KEY);
  sessionStorage.removeItem(SSO_USER_KEY);
}

/** Returns the best available auth token: SSO JWT > API key */
export function getAuthToken(): string | null {
  return getSsoJwt() || sessionStorage.getItem("itpmng_api_key");
}
